import { Component, OnInit } from '@angular/core';
import { TitleService } from '../../_core/services/title.service';
import Urls from '../../_core/contants/urls';
import { ActivatedRoute, Router } from '@angular/router';
import PageTitles from '../../_core/contants/page-titles';
import { SINNGEBER_FAQ_URL } from '../../_core/contants/faq';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-page-not-found',
  templateUrl: './page-not-found.component.html',
  styleUrls: ['./page-not-found.component.scss'],
})
export class PageNotFoundComponent implements OnInit {
  // Set by the route that stands in for a page which has moved elsewhere - currently Sinngeber's
  // /app/faqs, whose FAQs now live on Freshdesk (see pages-routing.module.ts). The catch-all '**'
  // route carries no data, so it keeps the generic not-found message.
  pageMoved = false;
  faqUrl = SINNGEBER_FAQ_URL;
  contactEmail = environment.mailTo;
  homeUrl = `/${Urls.APP}`;

  constructor(private router: Router, private route: ActivatedRoute, private titleService: TitleService) {}

  ngOnInit(): void {
    this.titleService.titleChanged(PageTitles.NOT_FOUND);
    this.pageMoved = !!this.route.snapshot.data.pageMoved;
  }

  goHome() {
    this.router.navigate([Urls.APP]);
  }
}
